import {
  Cmsmf,
  jkBaseForm,
  PageKind,
} from 'jk-service';
import { Component, OnInit, Injector, afterNextRender, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { jkSingleComponent } from './jkSingle';
import { entityState, JkEntityV2 } from 'jk-service';
import { RowClickedEvent, RowSelectedEvent } from 'ag-grid-community';
import { jkRestReturn } from 'jk-service';
import { CrudbarComponent } from 'jk-service';
import { JkaggridComponent } from './jkaggrid/jkaggrid.component';

/**
 * @description 單據模式的列舉
 */
export enum billMode {
  'data', // 資料
  'bill', // 單據
  'grid', // 表格
}

/**
 * @class JkBillFormComponent
 * @description
 * 處理具有主/明細結構的複雜單據表單的基礎元件。
 * 繼承自 jkBaseForm，提供 CRUD、狀態管理及多頁面區塊協調功能。
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class JkBillFormComponent extends jkBaseForm implements OnInit {
  crudbar!: CrudbarComponent; // ###
  //billSrv: JkbillService = new JkbillService(); // <JkEntityV2, undefined, undefined,undefined, undefined>
  masterVisible: boolean = true;
  detailVisible: boolean = true;
  bodyVisible: boolean = true;
  /** @description 主表單元件的實例 */
  masterPage!: jkSingleComponent;
  /** @description 明細表單元件的實例 */
  detailPage!: jkSingleComponent;
  bodyPage!: jkSingleComponent;
  footPage!: jkSingleComponent;
  handPage!: jkSingleComponent;
  /** @description 主表的資料實體服務 */
  get master(): JkEntityV2 | undefined {
    if (!this.masterPage) return undefined;
    return this.masterPage.srv;
  }
  //master!: JkEntityV2;
  /** @description 明細表的資料實體服務 */
  get detail(): JkEntityV2 | undefined {
    if (!this.detailPage) return undefined;
    return this.detailPage.srv;
  }
  get body(): JkEntityV2 | undefined {
    if (!this.bodyPage) return undefined;
    return this.bodyPage.srv;
  }
  get foot(): JkEntityV2 | undefined {
    if (!this.footPage) return undefined;
    return this.footPage.srv;
  }
  get hand(): JkEntityV2 | undefined {
    if (!this.handPage) return undefined;
    return this.handPage.srv;
  }
  batchSql: string[] = [];
  get item(): any {
    if (!this.masterPage) return undefined;
    if (!this.masterPage.srv) return undefined;
    return this.masterPage.srv.item;
  }

  _billState: entityState = entityState.dsBrowse;
  /**
   * @description 設定整個單據的目前狀態 (瀏覽、新增、編輯)
   * @param value 狀態
   */
  set billState(value: entityState) {
    // old masterState
    this._billState = value;
    //this._state = value;
    if (this.master && this.master.cbStateChanged) {
      this.master.cbStateChanged(value);
    }
  }

  /**
   * @description 取得整個單據的目前狀態
   */
  get billState(): entityState {
    return this._billState; //this.master.state;
  }
  _oldState: entityState = entityState.dsBrowse;
  get oldState(): entityState {
    return this.oldState;
  }
  set oldState(value: entityState) {
    this._oldState = value;
  }

  get isBrowse(): boolean {
    return this.billState === entityState.dsBrowse;
  }
  cmsmf: Cmsmf = new Cmsmf();
  numberLength: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  //ret: jkRestReturn = new jkRestReturnClass();
  _mode: billMode = billMode.data; //'資料' | '單據' | '表格' = '資料'; // billSrv 加combobox 單據(有單q別)/表格/資料 模式
  /*
  set billState(value: entityState) { // old masterState
    if (this.billSrv)
      this.billSrv.billState = value;
    if (this.master.cbStateChanged) {
      this.master.cbStateChanged(value);
    }
  }
  get billState(): entityState {
    return this.billSrv.billState;
  }
  get isBrowse(): boolean {
    return this.billSrv.isBrowse;
  }
  //_oldState: entityState = entityState.dsBrowse;
  get oldState(): entityState {
    return this.billSrv.oldState;
  }
  */
  constructor() {
    const injector = inject(Injector);

    super(injector);
    this.pageKind = PageKind.bill;

    //this.billSrv.billPage = this;
    this.titleOptionsClick.bind(this);
    //初次 -> afterNextRender；每次 -> afterRender
    afterNextRender(() => {
      this.doBillReady(); // 這行要放在 ngAfterViewInit 最後  ###
      //console.log('billform.ngAfterRender crudbar:', this.crudbar);
      this.initCrudbar(this.crudbar);
      //this.cdr.markForCheck();
    });
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  /**
   * @description
   * Angular 生命週期鉤子，在視圖初始化後執行。
   * 觸發 doBillReady 事件並初始化 crudbar。
   */
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  /** @description 當單據準備就緒時觸發的事件 */
  readonly onBillReady = output<any>();
  /**
   * @description 觸發 onBillReady 事件
   */
  doBillReady() {
    if (this.onBillReady) this.onBillReady.emit(this);
  }

  //@Output() onFormReady = new EventEmitter<JkBillFormComponent>();
  /**
   * @description
   * 在 masterPage 執行，用於初始化 detailPage。
   * 根據 pageKind 決定要初始化 master 還是 detail。
   * @param $event 事件物件
   * @param pageKind 頁面類型
   */
  override doFormReady($event: any, pageKind: PageKind) {
    super.doFormReady($event, pageKind);

    // 不會有 pageKind = data
    if (pageKind === PageKind.master) {
      this.doMasterPageReady($event);
    }
    if (pageKind === PageKind.detail) {
      this.doDetailPageReady($event);
    }
    if (pageKind === PageKind.hand) {
      this.doHandPageReady($event);
    }
  }
  /**
   * @description 當主表單元件準備就緒時呼叫，用於初始化主表相關的服務和事件。
   * @param $event 事件物件
   */
  doMasterPageReady($event: any) {
    this.masterPage = $event;
    if (!this.masterPage) return;
    this.masterPage.initCrudbar(this.crudbar); // jackie 20250828 add
    this.masterPage.cbBillDelete = this.childDelete.bind(this);
    this.masterPage.cbBillStateChanged = this.childStateChanged.bind(this);
    this.masterPage.cbBillPost = this.childPost.bind(this);
    this.masterPage.cbBillCancel = this.childCancel.bind(this);
    this.masterPage.cbBillRefresh = this.childRefresh.bind(this);
    this.masterPage.cbBillCancelEdit = this.childCancelEdit.bind(this);
    this.masterPage.cbBillAfterScroll = this.onMasterAfterScroll.bind(this);
    this.masterPage.cbGetMasterData = this.onGetMasterData.bind(this);
    if (this.detailPage)
      this.masterPage.setMasterHaveDetail(true);

  }
  async childDelete(params: any, ret: jkRestReturn): Promise<boolean> {
    if (!this.master)
      return false;
    /*if(this.master.itemIndex < 0){
      this.showAlert('請先選取資料!');
      return false;
    }*/
    let deleteItem = this.master.item;
    let keys = this.master.getKeyValues(this.master.item);
    let bool = await this.doDelete(keys, ret, true);
    if (bool) {
      if (this.masterGrid) {
        this.masterGrid.doDelete(deleteItem);
      }
    }
    return bool;
  }
  childStateChanged(state: entityState) {
    //this.billState = state;
  };
  async childPost(params?: any): Promise<boolean> {
    return true;
  }
  childCancel(item: any): boolean {
    let bool = true;
    return bool;
  }
  childRefresh(): void {
    this.doRefresh();
  }
  childCancelEdit(bool: boolean): void {
    //this.doCancelEdit(bool);
  }
  /**
   * @description 當明細表單元件準備就緒時呼叫，用於初始化明細表。
   * @param $event 事件物件
   */
  doDetailPageReady($event: any) {
    // ###
    this.detailPage = $event;
    if (!this.detailPage) return;

    if (true) {
      if (this.masterPage)
        this.masterPage.setMasterHaveDetail(true);
      // this.pageKind === PageKind.master
      this.detailPage.setEntityEvent(this.detailPage.srv); // ###
      //this.billSrv.init(this.detailPage.pageKind, this, this.detailPage.masterSrv); // ###
      this.detailPage.isCheckPower = false;
      this.detailPage.setFormOpt2(this.detailPage.title); //###
      this.detailPage.srv.sqlOrder = ` ORDER BY ${this.detailPage.gridInitOpt.sortField}  ${this.detailPage.gridInitOpt.sort} `;
      //this.detailPage.crudbar.init(this.detailPage.masterSrv);
      //this.detailPage.crudbar.initGrid(this.detailPage.masterGrid);
      if (this.detailPage.masterGrid)
        this.detailPage.masterGrid.setGridColumns(this.detailPage.srv);
    }
  }
  doHandPageReady($event: any) {
    // ###
    this.handPage = $event;
    if (!this.handPage) return;

    if (true) {
      if (this.masterPage)
        this.masterPage.setMasterHaveHand(true);
      // this.pageKind === PageKind.master
      this.handPage.setEntityEvent(this.handPage.srv); // ###
      //this.billSrv.init(this.detailPage.pageKind, this, this.detailPage.masterSrv); // ###
      this.handPage.isCheckPower = false;
      this.handPage.setFormOpt2(this.handPage.title); //###
      this.handPage.srv.sqlOrder = ` ORDER BY ${this.handPage.gridInitOpt.sortField}  ${this.handPage.gridInitOpt.sort} `;
      //this.detailPage.crudbar.init(this.detailPage.masterSrv);
      //this.detailPage.crudbar.initGrid(this.detailPage.masterGrid);
      if (this.handPage.masterGrid)
        this.handPage.masterGrid.setGridColumns(this.handPage.srv);
    }
  }
  /**
   * @description 主表捲動後觸發，用於載入對應的明細資料。
   * @param item 目前主表的項目
   * @param ret 後端回傳的結果
   */
  onMasterAfterScroll(item: any, ret: jkRestReturn): void {
    if (this.detailPage) {
      this.detailPage.doOpenDetail(item);
    }
  }

  onGetMasterData(): any {
    if (!this.masterPage) {
      this.showAlert('BillForm masterPage 未設定!');
      return undefined;
    }
    if (!this.masterPage.srv) {
      this.showAlert('BillForm masterSrv 未設定!');
      return undefined;
    }
    return this.masterPage.srv.item;
  }

  beforeInsert(item: any, ret: jkRestReturn) {
    this.onBeforeInsert(item, ret);
    if (ret.result) {
      //this.myState = entityState.dsInsert;
    }
  }
  afterInsert(item: any, ret: jkRestReturn) {
    this.onAfterInsert(item, ret);
  }
  beforeEdit(item: any, ret: jkRestReturn) {
    this.onBeforeEdit(item, ret);

    if (ret.result) {
      //this.myState = entityState.dsEdit;
    }
  }
  override async doUIEdit(): Promise<void> {
    super.doUIEdit();
    if (!this.masterPage) {
      this.showAlert('masterPage 未設定!');
      return;
    }
    if (!this.power.editPower) {
      this.showMessage('無修改權限!');
      return;
    }
    this.setToolBar;
    this.copyToClone;
    this.masterPage.doUIEdit();
  }
  override async doUIDelete(): Promise<boolean> {
    super.doUIDelete();
    let bool = false;
    if (!this.masterPage) {
      this.showAlert('masterPage 未設定!');
      return bool;
    }
    if (!this.power.editPower) {
      this.showMessage('無修改權限!');
      return bool;
    }
    this.setToolBar;
    this.copyToClone;
    this.doMyDelete();
    return true;
  }
  setToolBar() {
    //this.crudbar.state = this.myState;
  }
  copyToClone() {
    //this.master.copyToClone();
    if (this.detail) this.detail.copyToClone();
    if (this.body) this.body.copyToClone();
    if (this.hand) this.hand.copyToClone();
    if (this.foot) this.foot.copyToClone();
  }
  override async doUIInsert(e?: any): Promise<void> {
    super.doUIInsert(e);
    if (!this.masterPage) {
      this.showAlert('masterPage 未設定!');
      return;
    }
    if (!this.power.editPower) {
      this.showMessage('無新增權限!');
      return;
    }
    this.setToolBar;
    this.copyToClone;
    this.masterPage.doUIInsert();
  }
  doBeforeMyOk(): boolean {
    let bool = true;
    this.onBeforePost(this.item, this.ret);
    return bool;
  }
  /**
   * @description
   * 執行儲存操作 (新增或修改)。
   * 在儲存前會呼叫 onBeforePost 進行資料驗證，並處理交易。
   * @returns 回傳一個 Promise，表示操作是否成功。
   */
  async doMyOk(): Promise<boolean> {
    let oldState = this.billState;
    if (this.billState === entityState.dsBrowse) {
      this.showAlert('狀態錯誤,不是在編輯狀態!');
      this.doMyCancel();
      return false;
    }
    if (!this.doBeforeMyOk()) return false;
    if (!this.master) {
      this.showAlert('master 未設定!');
      return false;
    }
    let isOk = await this.master.doMyOk(); //  doPost();
    if (isOk) {
      if (oldState === entityState.dsInsert && this.master.isAutoConfirm) {
        this.doConfirm();
      }
    }

    /*   TODO:

  // 1125 ^_^ 960718 add begin
  if MyState = dsInsert then
  begin
    if MyCallWork.PRID = self.PRID then
    begin
      CallWork.ReturnValue := '';
      ms1 := self.MasterKeys;
      while ms1 <> '' do
      begin
        mFieldName := CutToken(ms1, ',');
        mField := qryMaster.FindField(mFieldName);
        if mField <> nil then
        begin
          if CallWork.ReturnValue = '' then
            CallWork.ReturnValue := mFieldName + '=' + mField.AsString
          else
            CallWork.ReturnValue := CallWork.ReturnValue + '||' + mFieldName +
              '=' + mField.AsString;
        end;

      end;
    end;
  end;
  // 1125 ^_^ 960718 add end
  */

    //this.myState = entityState.dsBrowse;
    this.setToolBar;
    return isOk;
  }
  doConfirm() { }
  doMyCancel(): boolean {
    let bool = false;
    if (!this.master) {
      this.showAlert('master 未設定!');
      return bool;
    }
    bool = this.master.doCancel();
    if (bool) {
      //this.myState = entityState.dsBrowse;
      this.setToolBar;
      //this.doMyRefresh();
    }
    return bool;
  }
  /**
   * @description
   * 執行刪除操作。
   * 會彈出確認對話框，並以交易方式刪除主表和所有關聯的子表資料。
   * @returns 回傳一個 Promise，表示操作是否成功。
   */
  async doMyDelete(): Promise<boolean> {
    this.ret.clear(true);
    if (!this.master) {
      this.showAlert('master 未設定!');
      return false;
    }
    let deleteItem = this.master.item;
    let bool = await this.doDelete(
      this.master.getKeyValues(this.master.item),
      this.ret
    );
    if (bool) {
      if (this.masterGrid) {
        let r = this.masterGrid.doDelete(deleteItem);
      }
    }
    return bool;
  }
  /**
   * @description
   * 核心刪除邏輯，會檢查關聯欄位並以交易方式刪除所有相關資料。
   * @param masterKey 主表的 Key
   * @param ret 後端回傳的結果
   * @param isConfirm 是否顯示確認對話框
   * @returns 回傳一個 Promise，表示操作是否成功。
   */
  async doDelete(
    masterKey: any,
    ret: jkRestReturn,
    isConfirm: boolean = true
  ): Promise<boolean> {
    if (!this.checkLinkField()) {
      return false;
    }
    if (isConfirm) {
      let bool = confirm('確定要刪除嗎?'); //this.showConfirm('確定要刪除嗎?');
      if (!bool) {
        return false;
      }
    }
    let detailItem: any = {};
    let bool = await this.deleteBill(masterKey, ret);
    if (bool) {
      // TODO: 先回上層.用UIRefresh
      //bool = this.deleteItemList(masterKey,ret); 其他 body,detail,foot...最好重query
      if (!this.master) {
        this.showAlert('master 未設定!');
        return false;
      }
      let newItem = this.master.deleteItemOnly(
        masterKey,
        this.master.keyFields
      );
      masterKey = this.master.getKeyValues(newItem);
      if (this.detail) {
        //let linkList = this.detail.linkMasterFields.split(','); //  TD001=TC001,TD002=TC002
        /*let keyObj = {}; //  { WL001: rowData.WD001 };
        for (let i = 0; i < linkList.length; i++) {
          let detailField = this.getToken(linkList[i], '=', 1);
          let masterField = this.getToken(linkList[i], '=', 2);
          keyObj[detailField] = rowData[masterField];
        }*/
        let childKey = this.linkFieldSet2Object(
          this.detail.linkMasterFields,
          newItem
        );
        await this.detail.linkMaster(childKey, this.detail.sqlOrderDefault);
        if (this.detail.itemList())
          detailItem = this.detail.itemList()[0]; // 給foot用
        else detailItem = {};
      }
      if (this.body) {
        let childKey = this.linkFieldSet2Object(
          this.body.linkMasterFields,
          newItem
        );
        await this.body.linkMaster(childKey, this.body.sqlOrderDefault);
      }
      if (this.hand) {
        let childKey = this.linkFieldSet2Object(
          this.hand.linkMasterFields,
          newItem
        );
        await this.hand.linkMaster(childKey, this.hand.sqlOrderDefault);
      }
      if (this.foot) {
        let childKey = this.linkFieldSet2Object(
          this.foot.linkMasterFields,
          detailItem
        );
        await this.foot.linkMaster(childKey, this.foot.sqlOrderDefault);
      }
    } else {
      this.showAlert('刪除失敗:' + ret.getResultError());
    }
    return ret.result;
  }
  checkLinkField() {
    let bool = true;
    if (this.detail) {
      if (!this.detail.linkMasterFields) {
        this.showAlert('Detail linkMasterFields 未設定!');
        bool = false;
      }
    }
    if (this.body) {
      if (!this.body.linkMasterFields) {
        this.showAlert('body linkMasterFields 未設定!');
        bool = false;
      }
    }
    if (this.hand) {
      if (!this.hand.linkMasterFields) {
        this.showAlert('hand linkMasterFields 未設定!');
        bool = false;
      }
    }
    if (this.foot) {
      if (!this.foot.linkMasterFields) {
        this.showAlert('foot linkMasterFields 未設定!');
        bool = false;
      }
    }
    return bool;
  }
  // 用doDelete
  private async deleteBill(
    masterKey: any,
    ret: jkRestReturn
  ): Promise<boolean> {
    //if(this.PageKind !== PageKind.master)
    //  return false;
    this.batchSql = [];
    let keyValues: any = {};
    let keyCount = Object.keys(masterKey).length;
    if (!this.master) {
      this.showAlert('master 未設定!');
      return false;
    }
    this.batchSql.push(this.master.makeSqlDelete(masterKey, keyCount));
    if (this.detail && this.detail.itemList()) {
      for (let i = 0; i < this.detail.itemList().length; i++) {
        keyValues = this.detail.getKeyValues(this.detail.itemList()[i]);
        this.batchSql.push(
          this.detail.makeSqlDelete(keyValues, this.detail.keyFields.length)
        );
      }
    }
    if (this.body && this.body.itemList()) {
      for (let i = 0; i < this.body.itemList().length; i++) {
        keyValues = this.body.getKeyValues(this.body.itemList()[i]);
        this.batchSql.push(this.body.makeSqlDelete(keyValues, keyCount));
      }
    }
    if (this.foot && this.foot.itemList()) {
      for (let i = 0; i < this.foot.itemList().length; i++) {
        keyValues = this.foot.getKeyValues(this.foot.itemList()[i]);
        this.batchSql.push(this.foot.makeSqlDelete(keyValues, keyCount));
      }
    }
    if (this.hand && this.hand.itemList()) {
      for (let i = 0; i < this.hand.itemList().length; i++) {
        keyValues = this.hand.getKeyValues(this.hand.itemList()[i]);
        this.batchSql.push(this.hand.makeSqlDelete(keyValues, keyCount));
      }
    }
    ret = await this.orm.transactionSql(this.batchSql);
    if (!ret.result) {
      this.showAlert('刪除失敗:' + ret.getResultError());
    }
    return ret.result;
  }
  deleteItemList(masterKey: any, ret: jkRestReturn): boolean {
    ret.result = true;
    if (!this.master) {
      this.showAlert('master 未設定!');
      return false;
    }
    this.master.deleteItemOnly(masterKey, this.master.keyFields);
    ret.rowsAffected += ret.rowsAffected;
    // TODO: 這裡要改成用keyCount
    if (this.detail) {
      for (let i = 0; i < this.detail.itemList().length; i++) {
        this.detail.deleteItemOnly(masterKey, this.detail.keyFields);
        ret.rowsAffected += ret.rowsAffected;
      }
    }
    if (this.body) {
      for (let i = 0; i < this.body.itemList().length; i++) {
        this.body.deleteItemOnly(masterKey, this.body.keyFields);
        ret.rowsAffected += ret.rowsAffected;
      }
    }
    if (this.foot) {
      for (let i = 0; i < this.foot.itemList().length; i++) {
        this.foot.deleteItemOnly(masterKey, this.foot.keyFields);
        ret.rowsAffected += ret.rowsAffected;
      }
    }
    if (this.hand) {
      for (let i = 0; i < this.hand.itemList().length; i++) {
        this.hand.deleteItemOnly(masterKey, this.hand.keyFields);
        ret.rowsAffected += ret.rowsAffected;
      }
    }
    return ret.result;
  }
  actionSheetOpt = {
    //header: '',
    cssClass: 'action-sheet',
    buttons: [
      {
        text: '新增',
        icon: 'add',
        handler: () => {
          this.doUIInsert(undefined);
        },
      },
      {
        text: '查詢',
        icon: 'search',
        handler: () => {
          this.doUIQuery(undefined);
        },
      },
      {
        text: '重新整理',
        icon: 'refresh',
        handler: () => {
          this.doMyRefresh();
        },
      },
      {
        text: '至頂端',
        icon: 'arrow-up',
        handler: () => {
          this.listScrollTop();
        },
      },
      {
        text: '取消',
        // icon: 'close',
        role: 'cancel',
        data: {
          action: 'cancel',
        },
        //handler: () => {},
      },
    ],
  };
  onListItemSwipe($event: any) {
    this.listItemOptions($event);
  }
  onListItemClick($event: any) {
    let e = $event;
  }
  onListItemHold($event: any) {
    //let e = $event.itemData;
    this.listItemOptions($event);
  }
  onListItemDeleted($event: any) {
    let e = $event;

    this.doMyDelete();
  }
  async doMyRefresh(e?: any) {
    /*if(this.masterGrid){
      await this.masterGrid.instance.refresh();
    }
    if(this.masterList){
      this.masterList.instance.reload(); // ATT: reload()畫面會卡住?
    }*/
  }

  async listToolButtonClick(itemData: any) {
    let listActionSheetOpt = {
      // header: '',
      cssClass: 'action-sheet',
      buttons: [
        {
          text: '新增',
          icon: 'add',
          handler: () => {
            this.doUIInsert(undefined);
          },
        },
        {
          text: '修改',
          icon: 'create',
          handler: () => {
            this.doUIEdit();
          },
        },
        {
          text: '刪除',
          icon: 'trash',
          handler: () => {
            this.doUIDelete();
          },
        },
        {
          text: '取消',
          role: 'cancel',
          handler: () => { },
        },
      ],
    };
  }

  async listItemOptions($event: any) {
    let itemData = $event.itemData;
    await this.listToolButtonClick(itemData);
  }
  listScrollTop() {
    //if(this.masterList)
    //  this.masterList.instance.scrollTop();
  }
  async showEdit() {
    //const modal = await this.modalCtrl.open(this.editModalOpt);//create(this.editModalOpt);
    //await modal.present();
    //const { data, role } = await modal.onDidDismiss();
    //modal.close();
    //if (data) {
    //}
  }
  override async doUIQuery(e?: any) {
    super.doUIQuery(e);
    if (this.masterPage) {
      this.masterPage.doUIQuery();
    }
    //const modal = await this.modalCtrl.create(this.queryModalOpt);
    //const modal = this.modalCtrl.open(this.queryModalOpt);

    //await modal. //.present();
    //const { data, role } = modal.close() ; // onDidDismiss();
    //modal.close() ; // onDidDismiss();

    //if (data) {
    this.doMyRefresh(e);
    //}
  }
  /*
  onKeydown(event: KeyboardEvent) {
    // TODO: ctrl-ins 進行新增 ctrl-del 進行刪除
    if (event.ctrlKey && event.key === 'Insert') {
        this.doMyInsert();

      // 進行你的操作
      event.preventDefault(); // 防止事件的默認行為
    }
    if (event.ctrlKey && event.key === 'Delete') {
        this.doMyDelete();
      // 進行你的操作
      event.preventDefault(); // 防止事件的默認行為
    }
    //console.log('Ctrl:' + event.ctrlKey + ',key:' + event.key);
  }
  */
  // ag-grid begin-----------------------------------
  get masterGrid(): JkaggridComponent | undefined {
    if (!this.masterPage) return undefined;
    return this.masterPage.masterGrid;
  }
  get detailGrid(): JkaggridComponent | undefined {
    if (!this.detailPage) return undefined;
    return this.detailPage.masterGrid;
  }
  agRowClicked($event: RowClickedEvent<any, any>) {
    let rowIndex = $event.rowIndex;
    if (rowIndex === null) rowIndex = -1;
    if (this.masterGrid) this.masterGrid.rowIndex = rowIndex;
    else this.showAlert('billSrv masterGrid 未設定!');
    if (this.master) {
      //this.master.itemIndex = rowIndex;
      this.master.item = $event.data; // 會產生afterScroll 內含設定itemIndex
    } else this.showAlert('billSrv master 未設定!');
  }

  override doComReady(e: any, comName: string) {
    super.doComReady(e, comName);
    if (comName === 'crudbar') {
      this.crudbar = e;
      this.initCrudbar(this.crudbar);
    }
  }
  /*onCrudbarReady(e: CrudbarComponent) {
    // ###
    this.crudbar = e;
  }*/
  /**
   * @description 初始化 CRUD 工具列，將按鈕事件綁定到對應的表單操作。
   * @param crudbar
   */
  initCrudbar(crudbar: CrudbarComponent) {
    if (!crudbar) {
      console.log('billform.crudbar 未設定!');
      return;
    } else {
      crudbar.cbQuery = this.doUIQuery.bind(this);
      crudbar.cbInsert = this.doUIInsert.bind(this);
      crudbar.cbEdit = this.doUIEdit.bind(this);
      crudbar.cbPost = this.doUIPost.bind(this);
      crudbar.cbCancel = this.doUICancel.bind(this);
      crudbar.cbDelete = this.doUIDelete.bind(this);
      crudbar.cbHome = this.goHome.bind(this);
      crudbar.cbBack = this.goBack.bind(this);
    }
    if (this.masterPage) {
      console.log('billform this.masterPage 開始設定!');
      crudbar.cbQuery = this.doUIQuery.bind(this);
      crudbar.cbInsert = this.doUIInsert.bind(this);
      crudbar.cbEdit = this.doUIEdit.bind(this);
      crudbar.cbPost = this.doUIPost.bind(this);
      crudbar.cbCancel = this.doUICancel.bind(this);
      crudbar.cbDelete = this.doUIDelete.bind(this);
      crudbar.cbHome = this.goHome.bind(this);
      crudbar.cbBack = this.goBack.bind(this);
      if (this.masterPage && this.masterPage.crudbar) {
        this.masterPage.crudbar.visible.set(false);
      }
      if (this.masterPage.srv) {
        crudbar.onStateChanged = this.masterPage.srv.cbStateChanged.bind(
          this.masterPage
        );
      }
      if (this.masterPage.masterGrid)
        this.initCrudbarLinkGrid(crudbar, this.masterPage.masterGrid);
    } else {
      //console.log('billform this.masterPage 未設定!');
    }
  }
  initCrudbarLinkGrid(crudbar: CrudbarComponent, grid: JkaggridComponent) {
    if (!grid) {
      return;
    }
    crudbar.cbFirst = grid.onFirstRow.bind(grid);
    crudbar.cbPrevious = grid.onPreviousRow.bind(grid);
    crudbar.cbNext = grid.onNextRow.bind(grid);
    crudbar.cbLast = grid.onLastRow.bind(grid);
  }
  //[jkbillService] ------------------------------------------
  doMyEdit(): boolean {
    let bool = false;
    if (!this.item) {
      this.showAlert('請先選取資料');
      return bool;
    }
    if (!this.power.editPower) {
      this.showMessage('無修改權限!');
      return bool;
    }
    if (this.masterTabGroupCom) {
      // <mat-tab-group [selectedIndex]="selectedTabIndex">
      // 由於 selectedTabIndex 的值不會改變，所以用戶將無法切換到其他標籤。
      this.masterTabGroupCom.selectedIndex = 1; // TODO: 鎖定不能切到瀏覽頁
    }
    //this.myState = entityState.dsEdit;
    if (!this.master) {
      this.showAlert('master 未設定!');
      return bool;
    }
    this.master.state = entityState.dsEdit;
    /*if Assigned(EditFocus) then
      if EditFocus.CanFocus then
        EditFocus.SetFocus;
    */
    this.setToolBar;
    this.copyToClone;
    return true;
  }
  doMyInsert(e?: any) {
    let bool = false;
    if (!this.item) {
      this.showAlert('請先選取資料');
      return bool;
    }
    if (!this.power.insertPower) {
      this.showMessage('無新增權限!');
      return bool;
    }
    if (this.masterTabGroupCom) {
      // <mat-tab-group [selectedIndex]="selectedTabIndex">
      // 由於 selectedTabIndex 的值不會改變，所以用戶將無法切換到其他標籤。
      this.masterTabGroupCom.selectedIndex = 1; // TODO: 鎖定不能切到瀏覽頁
    }
    //this.myState = entityState.dsInsert;
    if (!this.master) {
      this.showAlert('master 未設定!');
      return bool;
    }
    this.master.state = entityState.dsInsert;
    this.setToolBar;
    this.copyToClone;
    this.doUIInsert();
    /*if Assigned(FirstFocus) then
      if FirstFocus.CanFocus then
        FirstFocus.SetFocus;
    */
    return true;
  }

  async doMyQuery(e?: any) {
    //const modal = await this.modalCtrl.create(this.queryModalOpt);
    //const modal = this.modalCtrl.open(this.queryModalOpt);

    //await modal. //.present();
    //const { data, role } = modal.close() ; // onDidDismiss();
    //modal.close() ; // onDidDismiss();

    //if (data) {
    this.doMyRefresh(e);
    //}
  }
  validCMSMF(dollar: string) {
    let mSQL: string;
    const FqrySimple: any[] = [];
    mSQL = `SELECT * FROM CMSMF WHERE MF001=${dollar}`;
    this.orm.simpleSql(this.host, mSQL).subscribe((data: any) => {
      if (data.length > 0) {
        let item = data[0];
        this.cmsmf.MF001 = item.MF001;
        this.cmsmf.MF002 = item.MF002;
        this.cmsmf.MF003 = item.MF003;
        this.cmsmf.MF004 = item.MF004;
        this.cmsmf.MF005 = item.MF005;
        this.cmsmf.MF006 = item.MF006;
        this.numberLength[5] = item.MF003;
        this.numberLength[6] = item.MF004;
        this.numberLength[7] = item.MF005;
        this.numberLength[8] = item.MF006;
      }
    });
  }
  /*
    onKeydown(event: KeyboardEvent) {
      // TODO: ctrl-ins 進行新增 ctrl-del 進行刪除
      if (event.ctrlKey && event.key === 'Insert') {
          this.doMyInsert();

        // 進行你的操作
        event.preventDefault(); // 防止事件的默認行為
      }
      if (event.ctrlKey && event.key === 'Delete') {
          this.doMyDelete();
        // 進行你的操作
        event.preventDefault(); // 防止事件的默認行為
      }
      //console.log('Ctrl:' + event.ctrlKey + ',key:' + event.key);
    }
    */
  // ag-grid begin-----------------------------------
  agRowSelected($event: RowSelectedEvent<any, any>) {
    // 會跑兩次. 一次是選取, 一次是取消選取
  }
  gridDelete(rowIndex: number) {
    // TODO:先delete 子表 detailEntity
    //this.masterGrid.instance.deleteRow(rowIndex);
  }
}
